import {
  Col as OrigCol,
  Container,
  Row as OrigRow,
} from "styled-bootstrap-grid";
import styled from "styled-components";

// styled-bootstrap-grid passes props like `auto`, `noGutter`, `alignSelf`, etc.
// as booleans to the DOM. In styled-components v6 these are no longer filtered
// automatically. Wrap Col and Row with shouldForwardProp to suppress the warning.
const GRID_PROPS = new Set([
  "auto",
  "noGutter",
  "noGutters",
  "alignSelf",
  "order",
  "offset",
  "hiddenXs",
  "hiddenSm",
  "hiddenMd",
  "hiddenLg",
  "hiddenXl",
]);

const Col = styled(OrigCol).withConfig({
  shouldForwardProp: (prop) => !GRID_PROPS.has(prop),
})`` as typeof OrigCol;

const Row = styled(OrigRow).withConfig({
  shouldForwardProp: (prop) => !GRID_PROPS.has(prop),
})`` as typeof OrigRow;

Col.displayName = "col";
Container.displayName = "container";
Row.displayName = "row";

export { Col, Container, Row };
